"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Dropdown = require("./Dropdown.provider");

var _icons = require("../../assets/icons");

var _DropdownMenuItem = require("./DropdownMenuItem.styles");

var _util = require("../../util");

var DropdownMenuItem = function DropdownMenuItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      highlight = _ref.highlight,
      itemKey = _ref.itemKey,
      item = _ref.item;

  var _useContext = (0, _react.useContext)(_Dropdown.DropdownContext),
      negativeHover = _useContext.negativeHover,
      onSelect = _useContext.onSelect,
      setOpen = _useContext.setOpen;

  var handleSelect = (0, _react.useCallback)(function () {
    if (typeof onSelect === 'function') {
      onSelect(itemKey, item);
    }

    setOpen(false);
  }, [onSelect, itemKey, setOpen, item]);
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    (0, _util.handleEnter)(e, handleSelect);
  }, [handleSelect]);
  return (0, _jsxRuntime.jsxs)("li", {
    tabIndex: 0,
    role: "menuitem",
    css: [_DropdownMenuItem.styles.base, negativeHover && _DropdownMenuItem.styles.negativeHover, highlight && _DropdownMenuItem.styles.highlight, process.env.NODE_ENV === "production" ? "" : ";label:DropdownMenuItem;"],
    className: className,
    onClick: handleSelect,
    onKeyDown: handleKeyDown,
    children: [children, (0, _jsxRuntime.jsx)("span", {
      css: _DropdownMenuItem.styles.icon,
      children: (0, _jsxRuntime.jsx)(_icons.Enter, {})
    })]
  });
};

DropdownMenuItem.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,
  className: _propTypes.string,

  /**
   * Whether to add light-grey background and black-medium font
   */
  highlight: _propTypes.bool,

  /**
   * itemKey will pass to onSelect function
   */
  itemKey: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,

  /**
   * item will passed to onSelect function
   */
  item: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool, _propTypes.number, _propTypes.object])
};
DropdownMenuItem.defaultProps = {
  className: undefined,
  highlight: false,
  item: undefined
};
var _default = DropdownMenuItem;
exports["default"] = _default;
//# sourceMappingURL=DropdownMenuItem.js.map